import { useTableMode } from '@Hooks/useTableModes';
import { type CreateInvoiceTableModes, createInvoiceTableModes } from './CreateInvoiceTableModes';
import { FrameCreateInvoicesFromOrders } from './FrameCreateInvoicesFromOrders';
import { FrameListLatestInvoices } from './FrameListLatestInvoices';

export function FrameCreateInvoices() {
    const tableModeProps = useTableMode<CreateInvoiceTableModes>('create', createInvoiceTableModes);

    if (tableModeProps.tableModeValue === 'latest') {
        return <FrameListLatestInvoices {...tableModeProps} />;
    } else {
        return <FrameCreateInvoicesFromOrders {...tableModeProps} />;
    }
}
